<template>
  <div v-if="!loading">
    <b-form>
      <div>
        <b-tabs no-nav-style nav-class="secondary-tabs">
          <b-tab
            :title="$t('tabs.general')"
            class="p-5"
            @click.prevent="updateVisibleSubmit(true)"
          >
            <budgets-form />
          </b-tab>
          <b-tab
            v-if="editBudget"
            :title="$t('tabs.proposal')"
            class="p-5"
            @click.prevent="updateVisibleSubmit(false)"
          >
            <proposal-form :viewIsLoading="loading" />
          </b-tab>
          <b-tab
            v-if="editBudget"
            :title="$t('tabs.history')"
            class="p-5"
            @click.prevent="updateVisibleSubmit(false)"
          >
            <history-list />
          </b-tab>
          <b-tab
            v-if="editBudget && approvedStatus"
            :title="$t('tabs.import_pdf')"
            class="p-5"
            @click.prevent="updateVisibleSubmit(false)"
          >
            <import-pdf-form />
          </b-tab>
          <edit-actions
            route-name="budgetsList"
            :is-visible-submit="isVisibleSubmit"
            :draftStatus="draftStatus"
            @save="submit"
          />
        </b-tabs>
      </div>
    </b-form>
  </div>
</template>

<script>
import budgetsForm from '@/components/budgets/form'
import proposalForm from '@/components/budgets/proposal/form'
import historyList from '@/components/budgets/proposal/history'
import importPdfForm from '@/components/budgets/proposal/importPdfForm'
import editActions from '@/components/common/editActions'
import model from '@/models/budgets'
import edit from '@/mixins/edit'
import api from '@/api/budgets'

export default {
  components: {
    budgetsForm,
    proposalForm,
    editActions,
    historyList,
    importPdfForm
  },
  mixins: [edit],
  watch: {
    '$store.state.form.relationshipFields.status': {
      handler(newVal) {
        this.proposalStatus = newVal
      }
    }
  },
  data: () => ({
    api,
    loading: false,
    model: JSON.parse(JSON.stringify(model.empty)),
    rules: model.rules,
    isVisibleSubmit: true,
    proposalStatus: null
  }),
  created() {
    this.init()
  },
  computed: {
    editBudget() {
      return this.$route.name && this.$route.name === 'budgetsUpdate'
    },
    draftStatus() {
      return !this.proposalStatus || this.proposalStatus.id === 1
    },
    approvedStatus() {
      return this.proposalStatus && this.proposalStatus.id === 3
    }
  },
  methods: {
    async init() {
      this.loading = true
      this.isVisibleSubmit = false

      if (this.$route.params.id) {
        await this.getItem()
      } else {
        this.initForm(this.model)
      }

      this.updateVisibleSubmit(this.draftStatus)
      this.loading = false
    },
    updateVisibleSubmit(value) {
      this.isVisibleSubmit = value
    }
  },
  validations: {
    ...model.rules
  }
}
</script>

